document.addEventListener('DOMContentLoaded', function () {
    const ativaMenu = document.querySelector('.ativa-menu');
    const conjuntoMenu = document.querySelector('.conjunto-menu-e-ativa');
    const links = document.querySelectorAll('.conjunto-menu-e-ativa a');
    const btnFechar = document.getElementById('fechar');
    const btnAbre = document.getElementById('abre');

    // Função para verificar o tamanho da tela e aplicar comportamentos
    function setupMenuBehavior() {
        // Desktop (1200px ou mais)
        if (window.innerWidth >= 1200) {
            // Remove eventos mobile/tablet se existirem
            btnAbre?.removeEventListener('click', toggleMenuMobile);
            btnFechar?.removeEventListener('click', toggleMenuMobile);
            
            // Adiciona comportamentos desktop
            ativaMenu.addEventListener('mouseenter', showMenuDesktop);
            conjuntoMenu.addEventListener('mouseleave', hideMenuDesktop);
            
            // Fecha menu ao clicar em links (desktop)
            links.forEach(link => {
                link.addEventListener('click', hideMenuDesktop);
            });

        } 
        // Tablet (entre 769px e 1199px)
        else if (window.innerWidth >= 769) {
            // Remove eventos desktop se existirem
            ativaMenu.removeEventListener('mouseenter', showMenuDesktop);
            conjuntoMenu.removeEventListener('mouseleave', hideMenuDesktop);
            
            // Adiciona comportamentos tablet (similar ao desktop mas com toques)
            ativaMenu.addEventListener('click', toggleMenuTablet);
            
            // Fecha menu ao clicar em links ou no botão fechar
            links.forEach(link => {
                link.addEventListener('click', hideMenuTablet);
            });
            btnFechar?.addEventListener('click', hideMenuTablet);

        } 
        // Mobile (768px ou menos)
        else {
            // Remove eventos desktop/tablet se existirem
            ativaMenu.removeEventListener('mouseenter', showMenuDesktop);
            conjuntoMenu.removeEventListener('mouseleave', hideMenuDesktop);
            ativaMenu.removeEventListener('click', toggleMenuTablet);
            
            // Adiciona comportamentos mobile
            btnAbre?.addEventListener('click', toggleMenuMobile);
            btnFechar?.addEventListener('click', toggleMenuMobile);
            
            // Fecha menu ao clicar em links (mobile)
            links.forEach(link => {
                link.addEventListener('click', toggleMenuMobile);
            });
        }
    }

    // Funções auxiliares
    function showMenuDesktop() {
        ativaMenu.classList.add('oculto');
        conjuntoMenu.classList.add('visivel');
    }

    function hideMenuDesktop() {
        ativaMenu.classList.remove('oculto');
        conjuntoMenu.classList.remove('visivel');
    }

    function toggleMenuTablet() {
        ativaMenu.classList.toggle('oculto');
        conjuntoMenu.classList.toggle('visivel');
    }

    function hideMenuTablet() {
        ativaMenu.classList.remove('oculto');
        conjuntoMenu.classList.remove('visivel');
    }

    function toggleMenuMobile() {
        ativaMenu.classList.toggle('oculto');
        conjuntoMenu.style.display = conjuntoMenu.style.display === 'flex' ? 'none' : 'flex';
    }

    // Configura inicialmente
    setupMenuBehavior();

    // Reconfigura quando a janela é redimensionada
    window.addEventListener('resize', function() {
        setupMenuBehavior();
    });
});